import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";

const PaymentCancel: React.FC = () => {
  return (
    <PageLayout>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "content",
          textAlign: "center",
          height: "62vh",
          width: "full",
        }}
      >
        <h1 style={{ width: "100%", textAlign: "center" }}>Payment failed!</h1>
      </div>
    </PageLayout>
  );
};

export default PaymentCancel;
